import { Fragment, h } from "preact";
import { useContext } from "preact/hooks";

import { useFirestore, useFirestoreDocData } from "../lib/preactfire";
import { Context } from "../lib/globalState";

import Footer from "../components/Footer";
import CommentsTab from "../components/CommentsTabs";
import CommentItem from "../components/CommentItem";
import LoadingContentPreloader from "../components/LoadingContentPreloader";
import { removeOverlay } from "../lib/helper";

export default function SingleComment({ setVisible }) {
  const {
    state: { sharedCommentId },
  } = useContext(Context);

  // If URL consists of emoity_comment_id parameter with comment id
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const commentRef = useFirestore().collection("comment").doc(sharedCommentId);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const comment = useFirestoreDocData(commentRef);

  return (
    <Fragment>
      <div className="comment-container">
        <CommentsTab count={1} />
        <div className="comments-content-wrapper">
          <div className="comment-item-container">
            {comment ? (
              <Fragment>
                <CommentItem comment={comment} />
                <div className="loading-content">
                  <button
                    type="button"
                    name="button"
                    className="load-feed"
                    onClick={() =>
                      // window.location.replace(window.location.origin)
                      setVisible(true)
                    }
                  >
                    Load All Comments
                  </button>
                </div>
              </Fragment>
            ) : (
              <LoadingContentPreloader />
            )}
          </div>
        </div>
        <Footer />
      </div>
      <div
        id="mobile-overlay"
        class="mobile-overlay"
        onClick={() => removeOverlay()}
      />
    </Fragment>
  );
}
